module.exports = __webpack_public_path__ + "static/media/play.b20d7b0f.svg";